!function (window) {
  // !避免微信字体过大导致布局混乱
  // if (typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function") {
  //   handleFontSize();
  // } else {
  //   document.addEventListener("WeixinJSBridgeReady", handleFontSize, false);
  // }
  // function handleFontSize () {
  //   // 设置网页字体为默认大小
  //   WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize': 0 });
  //   // 重写设置网页字体大小的事件
  //   WeixinJSBridge.on('menu:setfont', function () {
  //     WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize': 0 });
  //   });
  // }

  /* 设计图文档宽度 */
  var docWidth = 750;
  var doc = window.document, docEl = doc.documentElement, resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
  // !是否微信环境
  var isWechat = function () {
    var _UA = window.navigator.userAgent;
    if (/micromessenger/i.test(_UA.match(/MicroMessenger/i))) {
      return true;
    }
    return false;
  }
  var recalc = (function refreshRem () {
    /* 窗口当前宽度，取整数 */
    var clientWidth = Math.floor(window.innerWidth);
    var clientHeight = Math.floor(window.innerHeight);
    var realWidth = clientWidth;
    if (clientWidth < clientHeight) { //竖屏
      realWidth = clientWidth;
    } else {//横屏
      realWidth = clientHeight;
    }
    /* 页面宽度大于 设计图文档宽度 时不再放大 */
    // clientWidth = clientWidth > docWidth ? docWidth : clientWidth;
    var oldSize = (realWidth / docWidth * 100);
    var fontSize = oldSize;
    docEl.style.fontSize = oldSize + 'px';

    /* 获取设置后的字体大小情况 - 因微信设置APP字体大小后会影响该设置 */
    if (isWechat()) {
      var nowSize = window.getComputedStyle(document.documentElement).fontSize;
      var oldSizeValue = parseFloat(oldSize, 10);
      var nowSizeValue = parseFloat(nowSize, 10);
      /* 当差值大于1时重新按差比计算出正确的px值 */
      if ((nowSizeValue - oldSizeValue) > 0.5 || (nowSizeValue - oldSizeValue) < -0.5) {
        var diff = oldSizeValue / nowSizeValue;
        fontSize = (realWidth / docWidth * 100 * diff);
        console.log('diff', diff)
        console.log('nowSizeValue - oldSizeValue', nowSizeValue - oldSizeValue)
      }
    }
    console.log('fontSize', fontSize)
    docEl.style.fontSize = fontSize + 'px';
    return refreshRem;
  })();

  if (!doc.addEventListener) return;
  window.addEventListener(resizeEvt, recalc, false);
  doc.addEventListener('DOMContentLoaded', recalc, false);
}(window);


// WEBPACK FOOTER //
// ./src/assets/resizeRem.js